let depth = 0

/** en.reloadForm/reloadPanel started by the element action that listeners are waiting for. */
export async function duringOwnedElementReload<T>(task: () => Promise<T>): Promise<T> {
  depth += 1
  try {
    return await task()
  } finally {
    depth -= 1
  }
}

export function isOwnedElementReload(): boolean {
  return depth > 0
}

export function reloadShouldAwaitPendingElementEvent(): boolean {
  return !isOwnedElementReload()
}
